module.exports = __webpack_public_path__ + "images/header_nav/pipeline-logo-dark.svg";